import React from "react";

const SearchIcon = (props) => {
  const { color = "#000000" } = props;

  return (
    <>
      {/* <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.4 13.4498L9.5 10.5498"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.83333 11.2165C8.77885 11.2165 11.1667 8.82866 11.1667 5.88314C11.1667 2.93762 8.77885 0.549805 5.83333 0.549805C2.88781 0.549805 0.5 2.93762 0.5 5.88314C0.5 8.82866 2.88781 11.2165 5.83333 11.2165Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg> */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10ZM18 10C18 11.8486 17.3703 13.5487 16.3174 14.9033L21.707 20.293L21.7754 20.3691C22.0957 20.7619 22.0731 21.3409 21.707 21.707C21.3409 22.0731 20.7619 22.0957 20.3691 21.7754L20.293 21.707L14.9033 16.3174C13.5487 17.3703 11.8486 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z"
          fill="#8998AD"
        />
      </svg>
    </>
  );
};

export default SearchIcon;
